import React, {Suspense} from "react";
import {UserDashboardOverview} from "../../components/Dashboard/UserDashboardOverview";
import {defer, LoaderFunctionArgs, useLoaderData, Await} from "react-router-dom";
import {getCustomerOverviewAnalytics} from "../../api/analyticsClient";
import {CampaignAnalyticsSummary} from "../../model/CampaignAnalyticsSummary";
import {CircularProgress} from "@mui/material";

const UserDashboardPage: React.FC = () => {
    const { campaigns } = useLoaderData() as { 
        campaigns: Promise<CampaignAnalyticsSummary[]>;
    };
    
    return (
        <Suspense fallback={<CircularProgress/>}>
            <Await resolve={campaigns}>
                {(loadedCampaigns) => (
                    <UserDashboardOverview 
                        campaigns={loadedCampaigns}
                    />
                )}
            </Await>
        </Suspense>
    )
}

export default UserDashboardPage

async function loadCampaigns(customerId: string): Promise<CampaignAnalyticsSummary[]> {
    try {
        const response = await getCustomerOverviewAnalytics(customerId);
        if (!response.ok) {
            return [];
        }
        const allCampaigns: CampaignAnalyticsSummary[] = await response.json();
        return allCampaigns;
    } catch (error) {
        return [];
    }
}

export async function loader({ params }: LoaderFunctionArgs) {
    const customerId = params.customerId!;
    
    return defer({
        campaigns: loadCampaigns(customerId)
    });
}

